(function($) {
  function showPopup(selector) {
    $(selector).addClass('active');
  } window.showPopup=showPopup;

  function hidePopup(selector) {
    $(selector).removeClass('active');
  }

  function closeQuickView() {
    hidePopup('.tshopify-popup');
    $('body').removeClass('qv-open');
    setTimeout(function(){
      $('.loading').removeClass('loaded-content');
    }, 400);
  } window.closeQuickView = closeQuickView;

  function qtyProduct() {
    $(document).off('click.qvQty', '.quickview-product .qtyplus').on('click.qvQty', '.quickview-product .qtyplus', function(e){
      e.preventDefault();
      var fieldName = $(this).attr('data-field');
      var $input = $('.quickview-product input[name='+fieldName+']');
      var currentVal = parseInt($input.val(), 10);
      $input.val(!isNaN(currentVal) ? currentVal + 1 : 1);
    });

    $(document).off('click.qvQtyMinus', '.quickview-product .qtyminus').on('click.qvQtyMinus', '.quickview-product .qtyminus', function(e) {
      e.preventDefault();
      var fieldName = $(this).attr('data-field');
      var $input = $('.quickview-product input[name='+fieldName+']');
      var currentVal = parseInt($input.val(), 10);
      if (!isNaN(currentVal) && currentVal > 1) {
        $input.val(currentVal - 1);
      } else {
        $input.val(1);
      }
    });
  }
  window.qtyProduct=qtyProduct;

  function doAjaxAddToCart(variant_id, quantity, title, image) {

    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json',
      beforeSend: function() {
        showPopup('.loading');
      },
      success: function(msg) {


        $('.tshopify-popup').removeClass('active');
        hidePopup('.quickview-product');
        $('body').removeClass('qv-open');
        Shopify.getCart(function(cart) {
          tbuildCart(cart);
        });
      },
      error: function(xhr, text) {
        hidePopup('.loading');
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        showPopup('.error-popup');
      }
    });
  }window.doAjaxAddToCart=doAjaxAddToCart;

  function tbuildCart(cart) {
    // Start with a fresh cart div
    var $cartContainer = $('.enj-minicart-ajax');
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
      .append('<p>' + "سلة التسوق فارغة حالياً." + '</p>');
      cartCallback(cart);
      return;
      $('.js-number-cart').removeClass('active');
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, ajaxCartConfig.moneyFormat),
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, ajaxCartConfig.moneyFormat)
    }

    $cartContainer.append(template(data));
    $('.enj-cartcount').html(cart.item_count);
    $('body').removeClass('drawer--is-loading');
    $('body').trigger('ajaxCart.afterCartLoad', cart);
    $('.js-call-minicart').click();
    $('.js-number-cart').addClass('active');
  };

  function convertToSlug(text) {
    return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  } window.convertToSlug=convertToSlug;

  function qvMoney(cents) {
    var fmt = window.money_format || '';
    try {
      if (typeof currencyConverter === 'function' && (typeof shopCurrency !== 'undefined' || window.shop_currency || window.shopCurrency)) {
        if (typeof shopCurrency === 'undefined') {
          window.shopCurrency = window.shop_currency || 'USD';
        }
        return Shopify.formatMoney(currencyConverter(cents), fmt);
      }
    } catch (e) {}
    return Shopify.formatMoney(cents, fmt);
  }

  function qvRefreshCurrency() {
    try {
      if (window.TurkwayCurrency && typeof TurkwayCurrency.convertAll === 'function') {
        TurkwayCurrency.convertAll();
        return;
      }
      var from = (typeof shopCurrency !== 'undefined' ? shopCurrency : null) || window.shop_currency || window.shopCurrency;
      var $sel = jQuery('#currencies a.selected');
      if (typeof Currency !== 'undefined' && Currency.convertAll && from && $sel.length) {
        Currency.convertAll(from, $sel.attr('data-currency'));
        jQuery('.selected-currency').text(Currency.currentCurrency);
      }
    } catch (e) {}
  }


  $(document).ready(function() {
    // Event delegation: works for AJAX-loaded products + all viewports
    $(document).off('click.qvOpen', '.engoj_btn_quickview').on('click.qvOpen', '.engoj_btn_quickview', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openQuickView($(this));
      return false;
    });

    $(document).off('click.qvClose', '.overlay, .continue-shopping, .close-window, .overlay-quickview')
      .on('click.qvClose', '.overlay, .continue-shopping, .close-window, .overlay-quickview', function(e) {
        e.preventDefault();
        closeQuickView();
        return false;
      });

    $(document).off('keydown.qvEsc').on('keydown.qvEsc', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeQuickView();
      }
    });
  });


  function openQuickView($btn) {
    var id = $btn.data('id') || $btn.attr('data-id');
    if (!id) return;

    $('.loading').removeClass('loaded-content');
    showPopup('.loading');
    $('body').addClass('qv-open');

    var rating = (($btn.closest('.product-info, .product-item, .maxus-product').find('.spr-badge').attr('data-rating')) * 20) + "%";

    Shopify.getProduct(id, function(product) {
      try {
        var template = $('#quick-view').html();
        if (!template) {
          closeQuickView();
          return;
        }

        $('.quickview-product').html(template);
        var quickview = $('.quickview-product');
        quickview.find('.product-name a').html(product.title).attr('href', product.url);
        quickview.find('.spr-badge .spr-active').css({"width": rating});
        quickview.find('.star-rating .shopify-product-reviews-badge').attr('data-id', product.id);

        if (quickview.find('.des').length > 0 && product.description) {
          var description = product.description.replace(/(<([^>]+)>)/ig, "");
          description = description.split(" ").splice(0, 28).join(" ") + (description.split(" ").length > 28 ? "..." : "");
          quickview.find('.des').text(description);
        } else {
          quickview.find('.des').remove();
        }

        var moneyFmt = window.money_format || '';
        quickview.find('.qv-price-wrap .price, .price.product-price').first().html(qvMoney(product.price));
        quickview.find('.product-inner').attr('id', 'product-' + product.id);
        quickview.find('.variants').attr('id', 'product-actions-' + product.id);
        quickview.find('.variants select').attr('id', 'product-select-' + product.id);

        if (product.compare_at_price > product.price) {
          quickview.find('.compare-price').html(qvMoney(product.compare_at_price_max || product.compare_at_price)).show();
          quickview.find('.price').addClass('on-sale');
        } else {
          quickview.find('.compare-price').html('').hide();
          quickview.find('.price').removeClass('on-sale');
        }

        if (!product.available) {
          quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
          quickview.find(".btn-addToCart").text('غير متوفر').addClass('disabled').attr("disabled", "disabled");
        } else {
          quickview.find('.total-price span').html(qvMoney(product.price));

          
          tshopifyQuickview.createQuickViewVariantsSwatch(product, quickview);
          
        }

        qtyProduct();
        tshopifyQuickview.quickViewSlider(product, quickview);
        tshopifyQuickview.initQuickviewAddToCart();

        quickview.addClass('active');
        $('.loading').addClass('loaded-content').removeClass('active');

        if (quickview.find('.total-price').length > 0) {
          quickview.find('.qtyplus, .qtyminus').on('click', tshopifyQuickview.updatePricingQuickview);
        }

        qvRefreshCurrency();
      } catch (err) {
        console.error('Quickview error:', err);
        // Still show popup with whatever we have rather than dying silently
        $('.quickview-product').addClass('active');
        $('.loading').addClass('loaded-content').removeClass('active');
      }
    });
  }
  window.openQuickView = openQuickView;
  window.quickView = function(){}; // legacy no-op

  var tshopifyQuickview = {

    selectCallbackQuickview: function(variant, selector) {
      var self = this;
      var productItem = jQuery('.quickview-product .product-item'),
          addToCart = productItem.find('.btn-addToCart'),
          productPrice = productItem.find('.price'),
          comparePrice = productItem.find('.compare-price'),
          totalPrice = productItem.find('.total-price span');

      if (variant && variant.featured_image) {
        var originalImage = jQuery(".engoj_img_main_quickview");
        var newImage = variant.featured_image;
        var element = originalImage[0];
        Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
          var $el = $(element);
          $el.attr('src', newImageSizedSrc);
        });        
      }

      if (variant) {
        if (variant.available) {
          addToCart.removeClass('disabled').removeAttr('disabled').text('أضف إلى السلة');
                                                                        } else {
                                                                        
                                                                        addToCart.val('sold_out').addClass('disabled').attr('disabled', 'disabled').text('نفد المخزون');
        }
        productPrice.html(qvMoney(variant.price));



          if ( variant.compare_at_price > variant.price ) {
            comparePrice.html(qvMoney(variant.compare_at_price)).show();
            productPrice.addClass('on-sale');
          } else {
            comparePrice.hide();
            productPrice.removeClass('on-sale');
          }

          var form = jQuery('#' + selector.domIdPrefix).closest('form');
          for (var i=0,length=variant.options.length; i<length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
            if (radioButton.length) {
              radioButton.get(0).checked = true;
            }
          }


          var inventoryInfo = productItem.find('.product-inventory span');
          if (variant.available) {
            if (variant.inventory_management!=null) {
              inventoryInfo.text(variant.inventory_quantity + " " + 'in_stock');
            } else {
              inventoryInfo.text('many_in_stock');
            }
          } else {
            inventoryInfo.text('out_of_stock');
          }

          // Total:
          var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
          var unitPriceTextMatch = $('.quickview-product .price').text().match(regex);

          if (!unitPriceTextMatch) {
            regex = /([0-9]+[.|,][0-9]+)/g;
            unitPriceTextMatch = $('.quickview-product .price').text().match(regex);
          }

          if (unitPriceTextMatch) {
            var unitPriceText = unitPriceTextMatch[0];
            var unitPrice = unitPriceText.replace(/[.|,]/g, '');
            var quantity = parseInt($('.quickview-product input[name=quantity]').val());
            var totalPrice = unitPrice * quantity;
            totalPrice = currencyConverter(totalPrice);

            var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
            regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            if (!totalPriceText.match(regex)) {
              regex = /([0-9]+[.|,][0-9]+)/g;
            }
            totalPriceText = totalPriceText.match(regex)[0];

            var regInput = new RegExp(unitPriceText, "g");
            var totalPriceHtml = $('.quickview-product .price').html().replace(regInput, totalPriceText);

            $('.quickview-product .total-price span').html(totalPriceHtml);
          }

          if (variant && variant.featured_image) {
            var newImage = Shopify.resizeImage(variant.featured_image.src, 'small');
            newImage = newImage.replace(/https?:/,'');
            jQuery('.quick-view .quickview-more-views img').each(function() {
              var grandSize = jQuery(this).attr('src');
              if (grandSize == newImage) {
                jQuery(this).parent().trigger('click');
                return false;
              }
            });
          }

        } else {
          addToCart.text('unavailable').addClass('disabled').attr('disabled', 'disabled');
        }

        qvRefreshCurrency();

      },
        /* Quick View SWATCH */
        createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
          var self = this;
          if (product.variants.length > 1) {
            for (var i = 0; i < product.variants.length; i++) {
              var variant = product.variants[i];
              var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
              quickviewTemplate.find('form.variants > select').append(option);
            }

            new Shopify.OptionSelectors("product-select-" + product.id, {
              product: product,
              onVariantSelected: self.selectCallbackQuickview,
              enableHistoryState: false
            });

            var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
            var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
            var options = "";

            for (var i = 0; i < product.options.length; i++) {
              options += '<div class="swatch clearfix" data-option-index="' + i + '">';
              options += '<div class="header">' + product.options[i].name + '</div>';
              var is_color = false;
              if (/Color|Colour/i.test(product.options[i].name)) {
                is_color = true;
              }
              var optionValues = new Array();
              for (var j = 0; j < product.variants.length; j++) {
                var variant = product.variants[j];
                var value = variant.options[i];
                var valueHandle = convertToSlug(value);
                var forText = 'swatch-' + i + '_' + valueHandle;
                if (optionValues.indexOf(value) < 0) {
                  //not yet inserted
                  options += '<div data-value="' + value + '" class=" ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

                  
                  options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

                  if (is_color) {
                    
                    options += '<label class="link_color" for="' + forText + '" style="background-color: ' + valueHandle + ';"></label>';
                    
                    
                    
                  } else {
                    
                    options += '<label class="variant_other" for="' + forText + '">' + value + '</label>';
                    
                  }
                  options += '</div>';
                  if (variant.available) {
                    $('.quickview-product .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                  }
                  optionValues.push(value);
                }
              }
              options += '</div>';
            }
            quickviewTemplate.find('form.variants > select').after(options);
            quickviewTemplate.find('.swatch :radio').change(function() {
              var optionIndex = $(this).closest('.swatch').attr('data-option-index');
              var optionValue = $(this).val();
              $(this)
              .closest('form')
              .find('.single-option-selector')
              .eq(optionIndex)
              .val(optionValue)
              .trigger('change');
            });

            if (product.available && product.options.size > 1) {
              Shopify.optionsMap = {};
              Shopify.linkOptionSelectors(product);
            }

          } else {
            quickviewTemplate.find('form.variants > select').remove();
            var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
            quickviewTemplate.find('form.variants').append(variant_field);
          }
        },

          /* Quick View */
          createQuickViewVariants: function(product, quickviewTemplate) {
            var self = this;
            if (product.variants.length > 1) {
              for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                quickviewTemplate.find('form.variants > select').append(option);
              }

              new Shopify.OptionSelectors("product-select-" + product.id, {
                product: product,
                onVariantSelected: self.selectCallbackQuickview,
                enableHistoryState: false
              });

              //$('.quickview-product .single-option-selector').selectize();
              $('.quickview-product .selectize-input input').attr("disabled", "disabled");

              if (product.options.length == 1) {
                $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
              }

              quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
                $(this).html(product.options[i].name);
              });

            } else {
              quickviewTemplate.find('form.variants > select').remove();
              var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
              quickviewTemplate.find('form.variants').append(variant_field);
            }

          },

            /* Quick View VIEWMORE Slider */
            quickViewSlider: function(product, quickviewTemplate) {
              var featuredImage = Shopify.resizeImage(product.featured_image, 'grande');
              quickviewTemplate.find('.featured-image').append(
                '<a title="'+ product.title.replace(/"/g, '&quot;') +'" class="product-photo" href="' + product.url + '">' +
                '<img loading="eager" width="600" height="600" class="engoj_img_main_quickview" src="' + featuredImage + '" alt="' + product.title.replace(/"/g, '&quot;') + '"/>' +
                '</a>'
              );
              if (product.images.length > 1) {
                var quickViewCarousel = quickviewTemplate.find('.more-views .owl-carousel');

                for (var i = 0; i < product.images.length; i++) {
                  var grande = Shopify.resizeImage(product.images[i], 'grande');
                  var compact = Shopify.resizeImage(product.images[i], 'compact');
                  var item = '<div class="item"><a href="javascript:void(0)" data-image="' + grande + '"><img loading="lazy" width="120" height="120" src="' + compact + '" alt="" /></a></div>';
                  quickViewCarousel.append(item);
                }

                quickViewCarousel.find('a').click(function() {
                  var featureImage = quickviewTemplate.find('.featured-image img');
                  var newSrc = $(this).attr('data-image');
                  if (featureImage.attr('src') != newSrc) {
                    featureImage.attr('src', newSrc);
                  }
                });
                
                setTimeout(function(){
                  var img = quickviewTemplate.find('.owl-carousel .item');
                  if (img.length > 3 && $.fn.slick && !quickviewTemplate.find('.owl-carousel').hasClass('slick-initialized')) {
                    quickviewTemplate.find('.owl-carousel').slick({
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      dots: false,
                      arrows: false,
                      
                      rtl: true,
                      
                    });
                  }
                }, 200);

              } else {
                quickviewTemplate.find('.more-views').remove();
              }

            },

              /* Quick View ADD TO CART */
              initQuickviewAddToCart: function() {
                $('.quickview-product .btn-addToCart').off('click.qvAdd').on('click.qvAdd', function() {
                  var variant_id = $('.quickview-product select[name=id]').val();
                  if (!variant_id) {
                    variant_id = $('.quickview-product input[name=id]').val();
                  }
                  var quantity = $('.quickview-product input[name=quantity]').val() || 1;
                  var title = $('.quickview-product .product-name a').html();
                  var image = $('.quickview-product .featured-image img').attr('src');
                  if (!variant_id) return;
                  doAjaxAddToCart(variant_id, quantity, title, image);
                });
              },
                /* Quick View update Pricing */
                updatePricingQuickview: function() {
                  var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
                  var unitPriceTextMatch = $('.quickview-product .price').text().match(regex);

                  if (!unitPriceTextMatch) {
                    regex = /([0-9]+[.|,][0-9]+)/g;
                    unitPriceTextMatch = $('.quickview-product .price').text().match(regex);
                  }

                  if (unitPriceTextMatch) {
                    var unitPriceText = unitPriceTextMatch[0];
                    var unitPrice = unitPriceText.replace(/[.|,]/g, '');
                    var quantity = parseInt($('.quickview-product input[name=quantity]').val());
                    var totalPrice = unitPrice * quantity;

                    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
                    regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
                    if (!totalPriceText.match(regex)) {
                      regex = /([0-9]+[.|,][0-9]+)/g;
                    }
                    totalPriceText = totalPriceText.match(regex)[0];

                    var regInput = new RegExp(unitPriceText, "g");
                    var totalPriceHtml = $('.quickview-product .price').html().replace(regInput, totalPriceText);

                    $('.quickview-product .total-price span').html(totalPriceHtml);
                  }
                }

    }
  })(jQuery);